module.exports = __webpack_public_path__ + "img/20200323110823512.03d157f7.png";